export default __webpack_public_path__ + "static/media/alex-productions-cyberpunk-computer-game-idra.3c4dc1c8.mp3";